import React from 'react';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Input from '@material-ui/core/Input';

import InputControl from '~/components/Input/InputControl';
import GridContainer from '~/components/GridContainer';
import Col from '~/components/Col';

import FarmRecord from '~/records/FarmRecord';

const attrName = (attr) => FarmRecord.hummanAttributeName(attr);

export default function FormFields({ record, onChange}) {
  return (
    <Card>
      <CardContent>
        <GridContainer>
          <Col xs={12}>
            <InputControl
              autoFocus
              required
              name="name"
              label={attrName('name')}
              value={record.get('name')}
              type="text"
              inputComponent={Input}
              onChange={onChange}
            />
          </Col>
        </GridContainer>
      </CardContent>
    </Card>
  );
}